module.exports = __webpack_public_path__ + "img/google_classroom_icon.98261cd5.svg";